/**
 * "What I build" — the four problem shapes I get hired for.
 * Icon keys map to react-icons imports in Focus.jsx.
 */
export const focusAreas = [
  {
    id: 'llm',
    icon: 'brain',
    index: '01',
    title: 'LLM Applications & Agents',
    body:
      'Provider-agnostic orchestration layers, structured generation with validation, retries and graceful failure, plus context management and evaluation harnesses that keep behaviour stable as prompts and models change.',
    tags: ['LLM Orchestration', 'AI Agents', 'Structured Output', 'AI Evaluation'],
  },
  {
    id: 'rag',
    icon: 'db',
    index: '02',
    title: 'RAG & Knowledge Systems',
    body:
      'Retrieval pipelines over business-specific knowledge — ingestion, chunking, embedding and re-ranking — wired into conversational interfaces that answer from your data instead of guessing.',
    tags: ['RAG', 'Knowledge Bases', 'Conversational AI', 'Context Management'],
  },
  {
    id: 'distributed',
    icon: 'network',
    index: '03',
    title: 'Distributed Backends',
    body:
      'Event-driven microservices in Go, Python/FastAPI and Node.js — clear service boundaries, versioned API contracts, background workers, idempotency and consistency strategies designed before the code.',
    tags: ['Microservices', 'Event-Driven', 'API Design', 'Data Consistency'],
  },
  {
    id: 'platform',
    icon: 'shield',
    index: '04',
    title: 'Payments & Platform Reliability',
    body:
      'Financial-grade integrations with banks, gateways and enterprise platforms, secured with OAuth2/JWT/RBAC and operated with containerised delivery, CI/CD, monitoring and real incident response.',
    tags: ['Payment Rails', 'OAuth2 / RBAC', 'Docker & CI/CD', 'Observability'],
  },
];

/**
 * A compact, honest description of how I work — shown as a process strip.
 */
export const approach = [
  {
    step: 'Architect',
    text: 'Service boundaries, contracts and failure modes on paper before implementation.',
  },
  {
    step: 'Build',
    text: 'Clean architecture, separation of concerns, hands-on across the full stack.',
  },
  {
    step: 'Harden',
    text: 'Automated tests, AI evaluations, security review and load-realistic tuning.',
  },
  {
    step: 'Operate',
    text: 'Observability, incident root-cause analysis and preventative fixes that stick.',
  },
];
